import MagnetHero from './MagnetHero';

export default MagnetHero;
